// extracted by mini-css-extract-plugin
export default {"main":"Main_main__W0okm","main__content":"Main_main__content__i1wrb","main__content__body":"Main_main__content__body__u6s27"};